import { render, staticRenderFns } from "./CheckinRuleDetail.vue?vue&type=template&id=0b880ff0"
import script from "./CheckinRuleDetail.vue?vue&type=script&lang=js"
export * from "./CheckinRuleDetail.vue?vue&type=script&lang=js"
import style0 from "./CheckinRuleDetail.vue?vue&type=style&index=0&id=0b880ff0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports